import React, { Component } from 'react';
import Kanbanview from '../windows/DeskViews/Kanbanview';
import FormViewer from './FormViewer';
import TableViewer from './TableViewer';
import CalendarViewer from './views/CalendarViewer';
import CardViewer from './CardViewer'
import { translate } from '../utils/useful';
import GanttWindow from '../windows/GanttWindow';
import ReportViewer from './ReportViewer';
import Matrix from './views/matrix/Matrix';
import Pagination from './Pagination';
import ButtonAnimated from './buttons/ButtonAnimated';

class ViewSwitcher extends Component {

  state = {
    view: true
  }

  componentDidMount() {
  }

  componentDidUpdate(prevProps) {
    if (this.props.checkProps != prevProps.checkProps) {
      this.setState({ view: false }, () => {
        this.setState({ view: true })
      })
    }
    if (JSON?.stringify(this.props.data) != JSON?.stringify(prevProps.data)) {
    }
  }

  submitForm = () => {
    if (this.form) {
      let data = this.form.getForm()
      this.setState({ isLoadingPost: true })
      this.props.submitForm(data, false, () => {
        this.setState({ isLoadingPost: false })

        this.formContainer.scrollTo(0, 0)
        this.form.init()

      })
    }
  }

  render() {

    let type = this.props.type ?? this.props.view?.type
    return (
      <>
        <div className='w-100 h-100' style={{}}>
          {/* <div className='flexc pt-2 pb-2 px-2'>
          {['Tickets', 'Related', 'Setting'].map((tab, index) => {
            return (
              <div className='mrd-4' style={{borderBottom:index == 0 ? '2px solid rgb(0,126,190)':'2px solid transparent'}}>
                <p className='text-small'>{tab}</p>
              </div>
            )
          })}
        </div> */}
          {(!type || type == 'table' || !this.props.view) && (
            <div className='h-100 scroll-no-scrollbar '>
              <div className='pb-5 w-100' style={{ minHeight: '100%' }}>
                <TableViewer
                  fieldOptions={this.props.fieldOptions}
                  automations={this.props.automations}
                  duplicateField={this.props.duplicateField}
                  sortFieldRecord={this.props.sortFieldRecord}
                  insertField={this.props.insertField}
                  handleCopy={this.props.handleCopy}
                  groupByField={this.props.groupByField}
                  headers={(this.props.headers ?? this.props.page?.headers) ?? []}
                  page={this.props.page}
                  tempValue={this.props.tempValue}
                  updateRecord={this.props.updateRecord}
                  clearTempValue={this.props.clearTempValue}
                  data={JSON.parse(JSON.stringify(this.props.data ?? {}))}
                  top={0}
                  permissions={this.props.permissions}
                  applet={this.props.applet}
                  actions={this.props.actions}
                  width={this.props.width}
                  functionsHandler={this.props.functionsHandler}
                  changeValue={this.props.changeValue}
                  saveUserSettings={this.props.saveUserSettings}
                  userSettings={this.props.userSettings}
                  stackedKey={this.props.stackedKey}
                  view={this.props.view}
                  isLoading={this.props.isLoadingData}
                  setCurrentHead={this.props.setCurrentHead}
                  setData={this.props.setData}
                  currentHead={this.props.currentHead}
                  initData={this.props.initData}
                  variables={this.props.variables}
                  hideHeaderField={this.props.hideHeaderField}
                  deleteHeaderField={this.props.deleteHeaderField}
                  limit={this.props.limit}
                  currentPage={this.props.currentPage}
                  totalCount={this.props.totalCount}
                  changePage={this.props.changePage}
                  currentRecord={this.props.currentRecord}
                  currentRecordStage={this.props.currentRecordStage}
                  changeRecordStage={this.props.changeRecordStage}
                  setCurrentRecordStage={this.props.setCurrentRecordStage}
                  colors={this.props.colors}
                  params={this.props.params}

                />
                <div className="w-100 pt-2">
                  <Pagination currentPage={this.props.currentPage} totalCount={this.props.totalCount} limit={this.props.limit} changePage={this.props.changePage} colors={this.props.colors} />
                </div>
              </div>
            </div>
          )}

          {(type == 'card' || type == 'cards') && (
            <div className='h-100 scroll-no-scrollbar '>
              <div className='w-100'>
                <CardViewer
                  fieldOptions={this.props.fieldOptions}
                  automations={this.props.automations}
                  duplicateField={this.props.duplicateField}
                  sortFieldRecord={this.props.sortFieldRecord}
                  insertField={this.props.insertField}
                  handleCopy={this.props.handleCopy}
                  groupByField={this.props.groupByField}
                  headers={(this.props.headers ?? this.props.page?.headers) ?? []}
                  page={this.props.page}
                  tempValue={this.props.tempValue}
                  updateRecord={this.props.updateRecord}
                  clearTempValue={this.props.clearTempValue}
                  data={JSON.parse(JSON.stringify(this.props.data ?? {}))}
                  top={29}
                  permissions={this.props.permissions}
                  applet={this.props.applet}
                  actions={this.props.actions}
                  width={this.props.width}
                  functionsHandler={this.props.functionsHandler}
                  changeValue={this.props.changeValue}
                  saveUserSettings={this.props.saveUserSettings}
                  userSettings={this.props.userSettings}
                  stackedKey={this.props.stackedKey}
                  view={this.props.view}
                  isLoading={this.props.isLoadingData}
                  setCurrentHead={this.props.setCurrentHead}
                  setData={this.props.setData}
                  currentHead={this.props.currentHead}
                  initData={this.props.initData}
                  variables={this.props.variables}
                  hideHeaderField={this.props.hideHeaderField}
                  deleteHeaderField={this.props.deleteHeaderField}
                  limit={this.props.limit}
                  currentPage={this.props.currentPage}
                  totalCount={this.props.totalCount}
                  changePage={this.props.changePage}
                  currentRecord={this.props.currentRecord}
                  currentRecordStage={this.props.currentRecordStage}
                  changeRecordStage={this.props.changeRecordStage}
                  setCurrentRecordStage={this.props.setCurrentRecordStage}
                  colors={this.props.colors}
                  params={this.props.params}
                />
                {this.props.totalCount > this.props.limit && (
                  <div className="w-100 pt-2 pb-3">
                    <Pagination currentPage={this.props.currentPage} totalCount={this.props.totalCount} limit={this.props.limit} changePage={this.props.changePage} colors={this.props.colors} />
                  </div>
                )}
              </div>
            </div>
          )}

          {(type == "kanban" || type == "boards") && (
            <>
              <Kanbanview
                data={this.props.data}
                applet={this.props.applet}
                changeValue={this.props.changeValue}
                actions={this.props.actions}
                width={this.props.width}
                functionsHandler={this.props.functionsHandler}
                headers={this.props.headers ?? this.props.page?.headers}
                stackedKey={this.props.stackedKey}
                view={this.props.view}
                page={this.props.page}
                openSelectStack={this.props.openSelectStack}
                permissions={this.props.permissions}
                saveUserSettings={this.props.saveUserSettings}
                userSettings={this.props.userSettings}

                isLoading={this.props.isLoadingData}
                setCurrentHead={this.props.setCurrentHead}
                setData={this.props.setData}
                currentHead={this.props.currentHead}
                initData={this.props.initData}
                variables={this.props.variables}
                hideHeaderField={this.props.hideHeaderField}
                deleteHeaderField={this.props.deleteHeaderField}
                limit={this.props.limit}
                currentPage={this.props.currentPage}
                totalCount={this.props.totalCount}
                changePage={this.props.changePage}
                currentRecord={this.props.currentRecord}
                currentRecordStage={this.props.currentRecordStage}
                changeRecordStage={this.props.changeRecordStage}
                setCurrentRecordStage={this.props.setCurrentRecordStage}
                colors={this.props.colors}
                params={this.props.params}
                submitForm={this.props.submitForm}

              />
              <div className=" pt-2" style={{ position: 'absolute', bottom: 10, left: 10, zIndex: 2, }}>
                <Pagination currentPage={this.props.currentPage} totalCount={this.props.totalCount} limit={this.props.limit} changePage={this.props.changePage} colors={this.props.colors} hideInput={true} floatMode={true} />
              </div>
            </>

          )}

          {type == 'matrix' && (
            <>
              <Matrix

                data={this.props.data}
                applet={this.props.applet}
                changeValue={this.props.changeValue}
                actions={this.props.actions}
                width={this.props.width}
                functionsHandler={this.props.functionsHandler}
                headers={this.props.headers ?? this.props.page?.headers}
                stackedKey={this.props.stackedKey}
                view={this.props.view}
                page={this.props.page}

                openSelectStack={this.props.openSelectStack}
                permissions={this.props.permissions}
                saveUserSettings={this.props.saveUserSettings}
                userSettings={this.props.userSettings}

                isLoading={this.props.isLoadingData}
                setCurrentHead={this.props.setCurrentHead}
                setData={this.props.setData}
                currentHead={this.props.currentHead}
                initData={this.props.initData}
                variables={this.props.variables}
                hideHeaderField={this.props.hideHeaderField}
                deleteHeaderField={this.props.deleteHeaderField}
                limit={this.props.limit}
                currentPage={this.props.currentPage}
                totalCount={this.props.totalCount}
                changePage={this.props.changePage}
                currentRecord={this.props.currentRecord}
                currentRecordStage={this.props.currentRecordStage}
                changeRecordStage={this.props.changeRecordStage}
                setCurrentRecordStage={this.props.setCurrentRecordStage}
                colors={this.props.colors}
                params={this.props.params}
                submitForm={this.props.submitForm}
                defaultStackedKey={this.props.defaultStackedKey}
                currentFrame={this.props.currentFrame}
                changeStackedKey={this.props.setStackedKey}
              />
              {this.props.totalCount && this.props.limit}
              <div className=" pt-2" style={{ position: 'absolute', bottom: 10, left: 10, zIndex: 2, }}>
                <Pagination currentPage={this.props.currentPage} totalCount={this.props.totalCount} limit={this.props.limit} changePage={this.props.changePage} colors={this.props.colors} hideInput={true} floatMode={true} />
              </div>
            </>
          )}

          {type == 'calendar' && (
            <>
              <CalendarViewer
                data={this.props.data}
                applet={this.props.applet}
                changeValue={this.props.changeValue}
                stackedKey={this.props.stackedKey}
                actions={this.props.actions}
                width={this.props.width}
                headers={this.props.headers ?? this.props.page?.headers}
                submitForm={this.props.submitForm}
                functionsHandler={this.props.functionsHandler}
                view={this.props.view}
                openSelectStack={this.props.openSelectStack}
                page={this.props.page}

                permissions={this.props.permissions}
                saveUserSettings={this.props.saveUserSettings}
                userSettings={this.props.userSettings}

                isLoading={this.props.isLoadingData}
                setCurrentHead={this.props.setCurrentHead}
                setData={this.props.setData}
                currentHead={this.props.currentHead}
                initData={this.props.initData}
                variables={this.props.variables}
                hideHeaderField={this.props.hideHeaderField}
                deleteHeaderField={this.props.deleteHeaderField}
                limit={this.props.limit}
                currentPage={this.props.currentPage}
                totalCount={this.props.totalCount}
                changePage={this.props.changePage}
                currentRecord={this.props.currentRecord}
                currentRecordStage={this.props.currentRecordStage}
                changeRecordStage={this.props.changeRecordStage}
                setCurrentRecordStage={this.props.setCurrentRecordStage}
                colors={this.props.colors}
                params={this.props.params}
                defaultStackedKey={this.props.defaultStackedKey}
                currentFrame={this.props.currentFrame}
                changeStackedKey={this.props.setStackedKey}

              />
              <div className="w-100 pt-2">
                <Pagination currentPage={this.props.currentPage} totalCount={this.props.totalCount} limit={this.props.limit} changePage={this.props.changePage} colors={this.props.colors} />
              </div>
            </>
          )}

          {type == 'gantt' && (
            <>
              <GanttWindow
                changeValue={this.props.changeValue}
                applet={this.props.applet}
                timeLine={this.props.timeLine}
                stackedKey={this.props.stackedKey}
                view={this.props.view}
              />
              <div className="w-100 pt-2">
                <Pagination currentPage={this.props.currentPage} totalCount={this.props.totalCount} limit={this.props.limit} changePage={this.props.changePage} colors={this.props.colors} />
              </div>
            </>
          )}

          {type == 'report' && (
            <>
              <ReportViewer
                headers={this.props.headers ?? this.props.page?.headers}
                applet={this.props.applet}
                data={this.props.appletTasks} top={29}
                actions={this.props.actions}
                width={this.props.width}
                functionsHandler={this.props.functionsHandler}
                changeValue={this.props.changeValue}
                stackedKey={this.props.stackedKey}
                view={this.props.view}
              />
              <div className="w-100 pt-2">
                <Pagination currentPage={this.props.currentPage} totalCount={this.props.totalCount} limit={this.props.limit} changePage={this.props.changePage} colors={this.props.colors} />
              </div>
            </>
          )}

          {type == 'form' && (
            <div ref={el => this.formContainer = el} className='pt-3 px-2 flexc flex-column h-100 scroll-no-scrollbar pb-4'>
              <div style={{ maxWidth: 700 }}>
                <FormViewer
                  ref={el => this.form = el}
                  applet={this.props.applet}
                  headers={this.props.headers ?? this.props.page?.headers}
                  data={this.props.data} top={29}
                  actions={this.props.actions}
                  width={this.props.width}
                  functionsHandler={this.props.functionsHandler}
                  errors={this.props.errors}
                  formClass="bordered-form"
                  inputClass={'bordered-input'}
                  variables={this.state.variables}
                  stackedKey={this.props.stackedKey}
                  view={this.props.view}
                />
                {/* <div className="w-100 pt-2">
                  <Pagination currentPage={this.props.currentPage} totalCount={this.props.totalCount} limit={this.props.limit} changePage={this.props.changePage} colors={this.props.colors} />
                </div> */}
                <div className='px-3 flexce flexc-wrap'>
                  {/* <button className='flexcc px-3 mt-2'>
                      <p className='color-gray-2 text-semibold'>+ {translate("Submit and add new")}</p>
                  </button> */}


                  {/* <button onClick={() => this.props.submitForm()} className='px-1 py-1 mt-2 flexcb ' style={{
                
                    background: " linear-gradient(to right, rgb(229,46,77), rgb(229,46,77))", borderRadius: 6, color: '#fff', transition: 'all 0.5s',
                  }}>
                    <p className='text-small text-semibold mld-3 mrd-3 ' style={{ whiteSpace: 'nowrap' }}>{translate("Submit")}</p>
                    <div className='flexcc mld-3 p-1' style={{ background: 'linear-gradient(to right, #ffffff10, #ffffff20)', borderRadius: 8 }}>
                      <img className='invert' src='/assets/icons/plus.svg' height={18} />
                    </div>
                  </button> */}
                  <div className='flexce'>
                    <ButtonAnimated
                      iconwidth='24px'
                      icon='/assets/icons/plus-white.svg'
                      onClick={() => { this.submitForm() }}
                      isLoading={this.state.isLoadingPost}
                      title={translate('Submit')}
                      textColor={this.props.colors?.textColor ?? '#fff'}
                      invert={this.props.colors?.invert}
                      bg={this.props.colors?.background ?? ' linear-gradient(90deg, #5856D6, #7D7AFF)'}
                      width={'100%'}
                    />
                  </div>


                </div>
              </div>
            </div>
          )}

        </div>
      </>
    );
  }
}

export default ViewSwitcher;